var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompetitive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_451_10877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H60V60H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_451_10877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.255 58.2197H1.745V53.1677C1.74512 53.026 1.80146 52.8901 1.90165 52.7899C2.00183 52.6897 2.13768 52.6334 2.27937 52.6333H43.6026C43.8357 52.6333 44.0593 52.5407 44.2241 52.3759C44.3889 52.211 44.4815 51.9875 44.4815 51.7544C44.4815 51.5213 44.3889 51.2977 44.2241 51.1329C44.0593 50.9681 43.8357 50.8755 43.6026 50.8755H38.3833V28.9154H51.6343V50.8755H47.3482C47.1151 50.8755 46.8915 50.9681 46.7267 51.1329C46.5619 51.2977 46.4693 51.5213 46.4693 51.7544C46.4693 51.9875 46.5619 52.211 46.7267 52.3759C46.8915 52.5407 47.1151 52.6333 47.3482 52.6333H57.7207C57.8623 52.6334 57.9982 52.6897 58.0984 52.7899C58.1986 52.8901 58.2549 53.026 58.255 53.1677V58.2197ZM8.36574 35.6652H21.6167V50.8754H8.36574V35.6652ZM57.7207 50.8755H53.3921V28.7914C53.3921 27.8904 52.6592 27.1575 51.7584 27.1575H38.3833V20.7902C38.3833 19.8892 37.6504 19.1563 36.7495 19.1563H23.2505C22.3496 19.1563 21.6168 19.8892 21.6168 20.7902V27.0187C21.6168 27.2518 21.7094 27.4753 21.8743 27.6402C22.0391 27.805 22.2626 27.8976 22.4957 27.8976C22.7288 27.8976 22.9524 27.805 23.1172 27.6402C23.282 27.4753 23.3746 27.2518 23.3746 27.0187V20.9141H36.6255V50.8755H23.3746V30.7642C23.3746 30.5311 23.282 30.3076 23.1172 30.1427C22.9524 29.9779 22.7288 29.8853 22.4957 29.8853C22.2626 29.8853 22.0391 29.9779 21.8743 30.1427C21.7094 30.3076 21.6168 30.5311 21.6168 30.7642V33.9074H8.24175C7.34082 33.9074 6.60793 34.6404 6.60793 35.5413V50.8755H2.27937C1.0155 50.8755 -0.0128174 51.9037 -0.0128174 53.1677V59.0986C-0.0128174 59.3317 0.0797798 59.5553 0.244607 59.7201C0.409434 59.8849 0.632988 59.9775 0.866089 59.9775H59.1339C59.367 59.9775 59.5906 59.8849 59.7554 59.7201C59.9202 59.5553 60.0128 59.3317 60.0128 59.0986V53.1677C60.0128 51.9037 58.9846 50.8755 57.7207 50.8755Z",
    fill: "url(#paint0_linear_451_10877)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1213 6.31798C27.3728 6.28144 27.6117 6.18427 27.8174 6.03485C28.0231 5.88543 28.1893 5.68825 28.3018 5.46029L29.9997 2.01978L31.6978 5.46029C31.8103 5.68827 31.9766 5.88547 32.1822 6.03489C32.3879 6.18431 32.6269 6.28146 32.8784 6.31798L36.6752 6.8697L33.9277 9.54791C33.7457 9.72531 33.6095 9.94434 33.5309 10.1861C33.4524 10.4279 33.4338 10.6851 33.4768 10.9356L34.1254 14.7172L30.7296 12.9318C30.5046 12.8134 30.2541 12.7516 29.9999 12.7516C29.7456 12.7516 29.4952 12.8134 29.2701 12.9318L25.8742 14.7172L26.5229 10.9356C26.5659 10.6851 26.5473 10.4278 26.4687 10.186C26.3901 9.94427 26.2539 9.72522 26.0718 9.54779L23.3244 6.8697L27.1213 6.31798ZM24.7734 10.7369L24.0767 14.7991C24.026 15.0875 24.0576 15.3843 24.1679 15.6555C24.2782 15.9268 24.4627 16.1614 24.7003 16.3326C25.1866 16.686 25.8192 16.7317 26.3517 16.4521L29.9997 14.5341L33.6479 16.4521C33.8733 16.5712 34.1243 16.6335 34.3792 16.6338C34.7028 16.6338 35.0244 16.5324 35.2993 16.3326C35.5369 16.1615 35.7214 15.9268 35.8317 15.6556C35.942 15.3844 35.9736 15.0876 35.9229 14.7992L35.2262 10.7369L38.1778 7.85994C38.3882 7.65632 38.537 7.39755 38.6071 7.11327C38.6773 6.82899 38.6659 6.53071 38.5743 6.25259C38.485 5.97378 38.3188 5.72579 38.095 5.53705C37.8711 5.34832 37.5986 5.22647 37.3087 5.18548L33.2299 4.59275L31.4059 0.896891C31.1399 0.357712 30.601 0.022789 29.9997 0.022789C29.3986 0.022789 28.8597 0.35771 28.5937 0.896772L26.7697 4.59275L22.6909 5.18548C22.401 5.22647 22.1285 5.34832 21.9046 5.53705C21.6808 5.72579 21.5146 5.97378 21.4252 6.25259C21.3337 6.53071 21.3223 6.829 21.3924 7.11329C21.4625 7.39757 21.6114 7.65634 21.8218 7.85994L24.7734 10.7369Z",
    fill: "url(#paint1_linear_451_10877)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7235 8.32812C42.7235 8.56123 42.8161 8.78478 42.9809 8.94961C43.1458 9.11443 43.3693 9.20703 43.6024 9.20703H44.8611C45.0942 9.20703 45.3178 9.11443 45.4826 8.94961C45.6474 8.78478 45.74 8.56123 45.74 8.32812C45.74 8.09502 45.6474 7.87147 45.4826 7.70664C45.3178 7.54182 45.0942 7.44922 44.8611 7.44922H43.6024C43.3693 7.44922 43.1458 7.54182 42.9809 7.70664C42.8161 7.87147 42.7235 8.09502 42.7235 8.32812Z",
    fill: "url(#paint2_linear_451_10877)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0878 3.06738C42.2092 3.06738 42.3327 3.04207 42.4505 2.98863L43.5967 2.46832C43.808 2.37135 43.9722 2.19464 44.0535 1.97687C44.1348 1.75909 44.1265 1.51799 44.0304 1.30632C43.9344 1.09465 43.7584 0.929651 43.5409 0.84744C43.3235 0.765229 43.0824 0.772498 42.8703 0.867656L41.7241 1.38785C41.541 1.47077 41.3919 1.61393 41.3015 1.79347C41.2112 1.97301 41.1851 2.17809 41.2277 2.37452C41.2702 2.57094 41.3788 2.74686 41.5353 2.87294C41.6918 2.99902 41.8868 3.06765 42.0878 3.06738Z",
    fill: "url(#paint3_linear_451_10877)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7241 15.2681L42.8703 15.7883C42.9841 15.8402 43.1078 15.8671 43.233 15.8672C43.4019 15.8673 43.5673 15.8186 43.7094 15.7271C43.8514 15.6356 43.9641 15.5051 44.0338 15.3512C44.1302 15.1389 44.1382 14.8971 44.0563 14.6789C43.9743 14.4607 43.809 14.284 43.5967 14.1877L42.4505 13.6675C42.3454 13.6198 42.232 13.5932 42.1166 13.5894C42.0013 13.5855 41.8863 13.6045 41.7783 13.645C41.6702 13.6856 41.5712 13.7471 41.487 13.826C41.4027 13.9048 41.3348 13.9995 41.2871 14.1046C41.1907 14.3168 41.1827 14.5586 41.2646 14.7768C41.3466 14.9951 41.5118 15.1718 41.7241 15.2681Z",
    fill: "url(#paint4_linear_451_10877)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2559 9.20703H16.5146C16.7477 9.20703 16.9712 9.11443 17.1361 8.94961C17.3009 8.78478 17.3935 8.56123 17.3935 8.32812C17.3935 8.09502 17.3009 7.87147 17.1361 7.70664C16.9712 7.54182 16.7477 7.44922 16.5146 7.44922H15.2559C15.0228 7.44922 14.7992 7.54182 14.6344 7.70664C14.4696 7.87147 14.377 8.09502 14.377 8.32812C14.377 8.56123 14.4696 8.78478 14.6344 8.94961C14.7992 9.11443 15.0228 9.20703 15.2559 9.20703Z",
    fill: "url(#paint5_linear_451_10877)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5203 2.46832L17.6665 2.98852C17.7804 3.04044 17.9041 3.06734 18.0292 3.06738C18.1982 3.06746 18.3636 3.01883 18.5056 2.92732C18.6477 2.8358 18.7603 2.70529 18.8301 2.55141C18.9264 2.33914 18.9345 2.09731 18.8525 1.8791C18.7706 1.66089 18.6053 1.48419 18.393 1.38785L17.2468 0.867656C17.1417 0.819929 17.0282 0.793376 16.9129 0.789515C16.7975 0.785653 16.6825 0.804559 16.5745 0.845152C16.4665 0.885745 16.3675 0.947229 16.2832 1.02609C16.1989 1.10495 16.131 1.19965 16.0833 1.30477C15.987 1.51701 15.9789 1.75884 16.0609 1.97704C16.1428 2.19525 16.3081 2.37196 16.5203 2.46832Z",
    fill: "url(#paint6_linear_451_10877)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6665 13.6676L16.5202 14.1878C16.4151 14.2355 16.3205 14.3035 16.2416 14.3878C16.1627 14.4721 16.1013 14.5711 16.0607 14.6791C15.9787 14.8973 15.9867 15.1392 16.0831 15.3515C16.1794 15.5637 16.3561 15.729 16.5743 15.811C16.7926 15.893 17.0344 15.885 17.2467 15.7886L18.3929 15.2683C18.6042 15.1713 18.7684 14.9946 18.8497 14.7769C18.931 14.5591 18.9227 14.318 18.8266 14.1063C18.7305 13.8946 18.5545 13.7296 18.3371 13.6474C18.1197 13.5652 17.8785 13.5725 17.6665 13.6676Z",
    fill: "url(#paint7_linear_451_10877)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_451_10877",
    x1: -0.0128174,
    y1: 39.5669,
    x2: 60.0128,
    y2: 39.5669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_451_10877",
    x1: 21.347,
    y1: 8.32829,
    x2: 38.6525,
    y2: 8.32829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_451_10877",
    x1: 42.7235,
    y1: 8.32813,
    x2: 45.74,
    y2: 8.32813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_451_10877",
    x1: 41.2078,
    y1: 1.92901,
    x2: 44.109,
    y2: 1.92901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_451_10877",
    x1: 41.2085,
    y1: 14.728,
    x2: 44.1124,
    y2: 14.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_451_10877",
    x1: 14.377,
    y1: 8.32813,
    x2: 17.3935,
    y2: 8.32813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_451_10877",
    x1: 16.0048,
    y1: 1.9282,
    x2: 18.9087,
    y2: 1.9282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_451_10877",
    x1: 16.0045,
    y1: 14.7289,
    x2: 18.9052,
    y2: 14.7289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompetitive);
export default __webpack_public_path__ + "static/media/Competitive.13a8496f97535e2dfed592e725e16078.svg";
export { ForwardRef as ReactComponent };